export default __webpack_public_path__ + "static/images/social-wall-graphic.png?96a1f22ab85d53469c1ae626e79cade8";